// extracted by mini-css-extract-plugin
export default {"containerUsuario":"UserHistory_containerUsuario__NeNnJ","comments":"UserHistory_comments__K4Yas"};